export const {
  NODE_ENV,
  GTM_TAG_ID,
  UMAMI_TRACKING_URL,
  UMAMI_TRACKING_ID,
  CLASSIC_WEBSITE_URL,
  MODERN_WEBSITE_URL,
  TRANSAK_API_KEY,
  TRANSAK_ENV,
} = {
  NODE_ENV: process.env.NEXT_PUBLIC_NODE_ENV,
  GTM_TAG_ID: process.env.GTM_TAG_ID,
  UMAMI_TRACKING_URL: process.env.UMAMI_TRACKING_URL,
  UMAMI_TRACKING_ID: process.env.UMAMI_TRACKING_ID,
  CLASSIC_WEBSITE_URL: process.env.NEXT_PUBLIC_CLASSIC_WEBSITE_URL,
  MODERN_WEBSITE_URL: process.env.NEXT_PUBLIC_MODERN_WEBSITE_URL,
  TRANSAK_API_KEY: process.env.NEXT_PUBLIC_TRANSAK_API_KEY,
  TRANSAK_ENV: process.env.NEXT_PUBLIC_TRANSAK_ENV,
}
